<template>
  <div class="jl-auc-success-wrap">
    <div class="jl-container">
      <v-breadcrumbs></v-breadcrumbs>
      <div class="jl-auc-success-content">
        <img src="../../../assets/img/zkj-auc-suc-icon.png" alt />
        <p class="text1">恭喜您成功拍得该锦鲤</p>
        <p class="text2">请在24小时内支付该订单，否则视为拍卖无效，200元押金不允退回！</p>
        <div class="item-footer">
          <button class="item-btn" @click="goback">稍后支付</button>
          <button class="item-btn active" @click="pay">立即支付</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from "../../../components/Breadcrumbs";
export default {
  name: "auctionDetailSuccess",
  components: {
    "v-breadcrumbs": Breadcrumbs
  },
  data() {
    return {
      breadData: [
        {
          path: "/auction",
          breadname: "拍卖中心"
        },
        {
          path: "/auction/detail",
          breadname: "拍卖详情"
        },
        {
          path: "/auction/success",
          breadname: "拍卖成功"
        }
      ]
    };
  },
  created() {
    this.breadData[1].path = "/auction/detail?id=" + this.$route.query.id;
  },
  methods: {
    pay() {
      this.$router.push({
        name: "orderList"
      });
    },
    goback() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
.jl-auc-success-wrap {
  background: #fff;
  padding-bottom: 180px;
}
.jl-container {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
.jl-breadcrumb {
  padding: 14px 0;
}
.jl-breadcrumb-list {
  .item {
    display: inline-block;
    vertical-align: middle;
    > a {
      font-size: 14px;
      color: #8b8b8b;
      &.active {
        color: #e50011;
      }
    }
  }
}
.jl-auc-success-content {
  padding-top: 100px;
  text-align: center;
  .text1 {
    font-size: 24px;
    color: #333;
    margin-bottom: 14px;
    font-weight: bold;
  }
  .text2 {
    font-size: 14px;
    color: #e50011;
    margin-bottom: 40px;
  }
  .item-footer {
    .item-btn {
      width: 128px;
      height: 42px;
      text-align: center;
      line-height: 42px;
      font-size: 16px;
      color: #333;
      border: 1px solid #666;
      margin: 0 10px;
      background-color: #fff;
      &.active {
        color: #fff;
        border-color: #e50011;
        background-color: #e50011;
      }
    }
  }
}
</style>
